"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button = function (_a) {
    var onClick = _a.onClick, text = _a.text, type = _a.type, name = _a.name, className = _a.className, id = _a.id, disabled = _a.disabled;
    var handleClick = function (event) {
        if (onClick != undefined) {
            onClick();
        }
    };
    return (react_1.default.createElement("button", { disabled: disabled, className: className, id: id, onClick: handleClick }, text));
};
exports.default = Button;
